<!--
 * @Descripttion: 表单预览
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="zone-mgmt-question-preview">
    <img class="phone" src="@/assets/手机框.png" alt="" />
    <div class="preview">
      <iframe
        id="iframe"
        :src="ifrSrc"
        frameborder="0"
        scrolling="no"
        width="375px"
        height="670px"
      ></iframe>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { computed } from 'vue';
import { useTempWebviewTaskUrl } from '@hooks/webview';
import { ProjectType } from '@cTypes/project';

const props = withDefaults(
  defineProps<{
    tempId: number;
    projectType: ProjectType;
  }>(),
  {}
);

// C端预览地址
const ifrSrc = computed(() => {
  return useTempWebviewTaskUrl({
    tempId: props.tempId,
    projectType: props.projectType
  });
});
</script>

<style lang="scss" scoped>
.zone-mgmt-question-preview {
  position: relative;
  width: 400px;
  height: 750px;
  .phone {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  .preview {
    position: absolute;
    left: 22px;
    top: 48px;
    transform: scale(0.95);
    transform-origin: top left;
  }
}
</style>
